<script>
import baseMixin from '@/mixins/baseMixin'
import { TimesheetOperationTypeInts } from '@/constants/disputes/TimesheetOperationType'
import timesheetMixin from '@/mixins/timesheetMixin'
import { highlightText } from '@/helpers/search-helpers'
import { DID_NOT_HAPPEN_DELTA_CODE } from '@/constants/disputes/DisputesDeltaCodes'

export default {
  name: 'DisputesTableSimpleDeltaV2',
  mixins: [baseMixin, timesheetMixin],
  props: {
    dispute: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  computed: {
    candidateHasSubmitted() {
      return this.dispute.hasCandidateTimesheet
    },
    clientHasSubmitted() {
      return this.dispute.hasClientTimesheet
    },
    hasCandidateModifiedTimesheet() {
      if (!this.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    hasClientModifiedTimesheet() {
      if (!this.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    candidateSubmittedDidNotHappen() {
      if (!this.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.operationType ===
        TimesheetOperationTypeInts.CANCEL
      )
    },
    clientSubmittedDidNotHappen() {
      if (!this.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.operationType ===
        TimesheetOperationTypeInts.CANCEL
      )
    },
    showDelta() {
      return (
        (this.hasCandidateModifiedTimesheet ||
          this.hasClientModifiedTimesheet ||
          this.candidateSubmittedDidNotHappen ||
          this.clientSubmittedDidNotHappen) &&
        this.dispute.deltaMinutes !== 0
      )
    },
    isDidNotHappen() {
      return this.dispute.deltaMinutes === DID_NOT_HAPPEN_DELTA_CODE
    },
    compDidNotHappenTooltipText() {
      return `${
        this.candidateSubmittedDidNotHappen
          ? this.dispute.candidateName
          : this.dispute.clientName
      } stated this booking did not happen`
    },
    isPositiveDelta() {
      return this.dispute.deltaMinutes >= 0
    },
    compDeltaMins() {
      const deltaMins = this.dispute.absoluteDeltaMinutes

      if (deltaMins === 0) return ''

      return `${deltaMins} mins`
    },
  },
  methods: {
    highlightText,
  },
}
</script>

<template>
  <div v-if="showDelta">
    <div v-if="isDidNotHappen">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" class="cursor-help" v-on="on">
            <v-icon size="14">mdi-alert-circle-outline</v-icon>
            <span
              v-sanitized-html="
                highlightText(
                  $t('dispute.bookingDetails.changes.didNotHappen'),
                  search
                )
              "
              class="text-caption ml-1"
            ></span>
          </div>
        </template>
        <span class="ws-pre-wrap">{{ compDidNotHappenTooltipText }}</span>
      </v-tooltip>
    </div>
    <div v-else class="text-caption">
      <v-icon size="14">{{
        isPositiveDelta ? 'mdi-plus' : 'mdi-minus'
      }}</v-icon>
      <span
        v-sanitized-html="highlightText(compDeltaMins, search)"
        class="text-caption ml-1"
      ></span>
    </div>
  </div>
  <span v-else>{{ $t('general.emptyCell') }}</span>
</template>
